(function (angular) {
    'use strict';

    angular.module('Common')
        /**
         *
         */
        .factory('callsService', ['$q', function ($q) {
            var _pendingPromises = [];
            var _pendingCalls = [];
            var _modalOpened;
            var fac = {
                addPendingCall: addPendingCall,
                isModalOpen: isModalOpen,
                openModal: openModal,
                closeModal: closeModal
            };
            function openModal() {
                _pendingPromises = [];
                _pendingCalls = [];
                _modalOpened = true;
            }
            function closeModal() {
                for (var i in _pendingPromises) {
                    _pendingPromises[i].resolve(_pendingCalls[i]);
                }
                _modalOpened = false;
            }
            function isModalOpen() {
                return _modalOpened;
            }
            function addPendingCall(config) {
                var deferred = $q.defer();
                if (_pendingCalls.filter(function (obj) { return obj.url == config.url && obj.method == config.method; }).length === 0) {
                    _pendingCalls.push(config);
                    _pendingPromises.push(deferred);
                }
                else {
                    deferred.reject();
                }
                return deferred.promise;
            }
            return fac;
        }]);


})(window.angular);
